const NewsTicker = () => {
    return (
        <div className="bg-red-600 text-white border-b border-red-700 h-10 w-full z-50 flex items-center justify-center px-4">
            <div className="font-bold text-center ticker-pulse">
                📢 Đang cập nhật nội dung bài học, thầy/cô vui lòng liên hệ Admin (0978531191) để đóng góp nội dung làm tư liệu dạy học. Trân trọng!
            </div>
            <style>{`
                @keyframes pulse {
                    0%, 100% {
                        opacity: 1;
                    }
                    50% {
                        opacity: 0.7;
                    }
                }
                
                .ticker-pulse {
                    animation: pulse 2s ease-in-out infinite;
                }
                
                .ticker-pulse:hover {
                    animation-play-state: paused;
                }
            `}</style>
        </div>
    );
};

export default NewsTicker;
